import {Component, HostListener, OnInit} from '@angular/core';
import {User} from "../models/user";
import {Event} from "../models/event";
import {AuthenticationService} from "../services/authentication.service";
import {EventService} from "../services/event.service";
import {Router, RouterLink} from "@angular/router";
import {Organization} from "../models/organization";
import {OrganizationService} from "../services/organization.service";
import {firstValueFrom} from "rxjs";
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from "@angular/material/sidenav";
import {OverviewFilterMenuComponent} from "../overview-filter-menu/overview-filter-menu.component";
import {DatePipe, LowerCasePipe, NgForOf, NgIf, NgStyle} from "@angular/common";

@Component({
  selector: 'app-my-organization-events-overview',
  templateUrl: './my-organization-events-overview.component.html',
  styleUrls: ['./my-organization-events-overview.component.css'],
  imports: [
    MatDrawerContent,
    MatDrawer,
    MatDrawerContainer,
    OverviewFilterMenuComponent,
    NgIf,
    NgStyle,
    DatePipe,
    RouterLink,
    LowerCasePipe,
    NgForOf
  ],
  standalone: true
})
export class MyOrganizationEventsOverviewComponent implements OnInit {
  user!: User;
  organization!: Organization;
  events!: Event[];

  searchTerm = "";
  eventTypeArray: string[] = [];
  disabilityArray: string[] = [];

  constructor(
    private authService: AuthenticationService,
    private orgService: OrganizationService,
    private eventService: EventService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.organization = await firstValueFrom(this.orgService.getOrganizationByRef(this.user.organization));

    this.eventService.getEventsByOrganization(this.user.organization).subscribe(events => {
      this.events = events;
    });
  }

  onInputValuesChange(emitValues: { inputValue: string, eventTypeArray: string[], disabilityArray: string[] }) {
    this.searchTerm = emitValues.inputValue;
    this.eventTypeArray = emitValues.eventTypeArray;
    this.disabilityArray = emitValues.disabilityArray;
  }

  redirectToEventSignees(eventID: string) {
    this.router.navigate([`/activiteit/details/${eventID}`]);
  }

  redirectToEvent(eventID: string) {
    this.router.navigate([`/activiteit/${eventID}`]);
  }

  /**
   * Combines the category filter and disability filter for readability
   */
  getFilteredEvents(): Event[] {
    const filteredByName = this.nameFilter(this.events);
    const filteredByCategory = this.categoryFilter(filteredByName);
    return this.disabilityFilter(filteredByCategory);
  }

  /**
   * Filters the events based on the searchterm used in the filter
   *
   * @param events
   */
  nameFilter(events: Event[]) {
    if (this.searchTerm != undefined) {
      return events.filter(event => event.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the category checkboxes
   *
   * @param events
   */
  categoryFilter(events: Event[]) {
    if (this.eventTypeArray.length > 0) {
      return events.filter(event => this.eventTypeArray.includes(event.category.toLowerCase()));
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the disability checkboxes
   *
   * @param events
   */
  disabilityFilter(events: Event[]) {
    if (this.disabilityArray.length > 0) {
      return events.filter(event =>
        this.disabilityArray.some(disability => event.accessibility[disability])
      );
    } else {
      return events;
    }
  }

  /**
   * Checks if the event dates are on the same day and month
   *
   * @return Boolean
   */
  eventDateTime(event: Event): Boolean {
    return event.start.toDate().getMonth() != event.end.toDate().getMonth() || event.start.toDate().getDay() != event.end.toDate().getDay();
  }
}
